/**  Тип проперти в декларации. */
export enum DeclarationPropertiesTypes {
  Unknown = -1,
  /** Текстовая.*/
  String = 0,

  /** Целочисленная. */
  Int = 1,

  /** Вещественная. */
  Decimal = 2,

  /** Логическая. */
  Boolean = 3,

  /** Дата-время. */
  DateTime = 4,

  /** Поле-счет.*/
  UserAccount = 5,

  /** Действие. */
  Action = 6,

  /** Поле-карты. */
  CardSelector = 7,

  /** Поле-карты. */
  BankBik = 8,

  ObjectsList = 9,

  File = 10,

  Accept = 11
}
